import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  FlexGrow, MobileFlex, ModelForm, ModelInput, ModelOutput,
} from '@equifinance/shared';
import Page from '../components/Page';
import { store, Dispatch, RootState } from '../store';

const CalculatorContainer = styled(MobileFlex)` ${({ theme }) => `
  width:100%;
  padding: ${theme.padding[4]};
  padding-right: 0;
  padding-left: 0;
`}`;

const CalculatorSection = styled(FlexGrow)<{rightBorder?: boolean}>` ${({ theme, rightBorder = false }) => `
  ${rightBorder ? `border-right:1px solid ${theme.borderFaint}` : ''};
  padding: ${theme.padding[8]};
  padding-bottom: 0;
  padding-top: 0;
`}`;

function Calculator() {
  const dispatch = useDispatch<Dispatch>();

  const calculatorId = '0';
  const calculator: any = useSelector((rootState: RootState) => rootState.calculator[calculatorId]);
  const updateCalculator = (values: any) => dispatch.calculator.UPDATE(values, calculatorId);

  const maxLoan = store.select.calculator.maxLoan(store.getState());
  const requiredLoan = store.select.calculator.requiredLoan(store.getState());
  const ltv = store.select.calculator.ltv(store.getState());
  const monthlyRepayment = store.select.calculator.monthlyRepayment(store.getState());

  return (
    <Page>
      <CalculatorContainer>
        <ModelForm model={calculator} update={updateCalculator}>
          <CalculatorSection>
            <ModelInput field="applicantIncome" label="Applicant Income" />
            <ModelInput field="propertyValue" label="Property Value" />
            <ModelInput field="firstChargeBalance" label="First Charge Balance" />
            <ModelInput field="firstChargeMonthlyRepayments" label="First Charge Monthly Repayments" />
          </CalculatorSection>
          <CalculatorSection rightBorder>
            <ModelInput field="totalUnsecuredBalance" label="Total Unsecured Balance" />
            <ModelInput field="loanRequired" label="Loan Required" />
            <ModelInput field="term" label="Term" />
          </CalculatorSection>
          <CalculatorSection>
            <ModelOutput id="maxLoan" field="" valueOverride={maxLoan} label="Max Loan" />
            <ModelOutput id="requiredLoan" field="" valueOverride={requiredLoan} label="Required Loan" />
            <ModelOutput id="ltv" field="" valueOverride={ltv} label="LTV" />
            <ModelOutput id="monthlyRepayment" field="" valueOverride={monthlyRepayment} label="Monthly Repayment" />
          </CalculatorSection>
        </ModelForm>
      </CalculatorContainer>
    </Page>
  );
}

export default Calculator;
